class tabs {
  constructor(elem) {
    this.elem = elem;
    this.tabButtons = this.elem.querySelectorAll('.js-tabs-btn');
    this.events()
  }

  events() {

    for (let tabButton of this.tabButtons) {

     

      tabButton.addEventListener('click', e => {
         
        for (let tabButton of this.tabButtons) {
          tabButton.classList.remove('active')
          this.elem.querySelector(tabButton.dataset.tabsTarget).classList.remove('active')
        }

        this.elem.querySelector(tabButton.dataset.tabsTarget).classList.add('active')
         tabButton.classList.add('active')
      })
    }

  }
}

const tabsElems = document.querySelectorAll('.js-tabs');

for (let tabsElem of tabsElems) {
  tabsElem.tabs = new tabs(tabsElem)
}
